export default __webpack_public_path__ + "media/integrations/safari-2fbddbd0.svg";